import { capitalizeWord } from "@hypexone/uicore";
import LanguagesList from "./LanguagesList";
import MenuComponent from "./MenuComponent";

type StateProps = {
  langSelected?: string;
  setLangSelected: any;
  buttonColor?: string;
};

const Languages: React.FC<StateProps> = (props) => {
  const { langSelected, setLangSelected, buttonColor } = props;
  const langCode =
    langSelected || sessionStorage.getItem("lang") || "en";

  return (
      <MenuComponent
        menuTitle={capitalizeWord(langCode)}
        menuList={<LanguagesList langSelected={langSelected} setLangSelected={setLangSelected} />}
        isToggleMenuManually
        buttonColor={buttonColor}
      />
    );
};

export default Languages;